import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import tooltip from 'simple-tooltip';
import { closest } from 'next/javascripts/modules/dom';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import updateTodoMixin from 'next/javascripts/mixins/update-todo-mixin';
import 'next/stylesheets/components/todo-item';
import resourceSubject from 'next/javascripts/reactivity/resource-subject';

Component('tr-todo-item', {
  mixins: [eventListenerMixin, updateTodoMixin],

  properties: {
    url: {
      type: String,
    },
    showProject: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    editing: {
      type: Boolean,
      default: false,
    },
    showAssigneeName: {
      type: Boolean,
      default: false,
    },
  },

  ready() {
    this.listenTo(this, {
      'tr-selector-field-list:opened': () => { this.editing = true; },
      'tr-selector-field-list:closed': () => { this.editing = false; },
      'tr-date-picker-field-list:opened': () => { this.editing = true; },
      'tr-date-picker-field-list:closed': () => { this.editing = false; },
      'tr-checkbox-field:change': this.handleCheckboxChange.bind(this),
      click: this.handleClick.bind(this),
      mouseover: this.handleMouseover.bind(this),
      mouseout: this.handleMouseout.bind(this),
    });
  },

  beforeCache() {
    this.editing = false;
  },

  handleMouseover(event) {
    event.stopPropagation();

    const assigneeSelect = this.querySelector('.tr-todo-assignee-select-field');
    if (this.showAssigneeName || !assigneeSelect) return;

    const assigneeResult = assigneeSelect
      .querySelector('.selector-field-result .selected-text');
    if (!assigneeResult || assigneeResult.hasAttribute('data-no-assignee')) return;

    if (this.tooltipHovering) {
      this.tooltipHovering = false;
      return;
    }

    $('.simple-tooltip').remove();

    this.tooltip = tooltip({
      el: assigneeSelect,
      content: assigneeResult.querySelector('.text').textContent,
      position: 'right',
    });
    this.tooltip.el.addClass('todo-item-assignee-tooltip');

    this.tooltip.show();
  },

  handleMouseout(event) {
    event.stopPropagation();

    if (event.relatedTarget
      && closest(event.relatedTarget, '.todo-item-assignee-tooltip')) {
      this.tooltipHovering = true;
    }

    if (!this.showAssigneeName) this.destroyAssigneeTooltip();
  },

  handleClick(event) {
    const { url } = this;
    const clickAssignee = closest(event.target, 'a.assignee-selector');
    if (clickAssignee) {
      this.destroyAssigneeTooltip();
      this.tooltipHovering = true;
      return;
    }

    if (!url) return;
    if (!this.editable) {
      event.preventDefault();
      event.stopPropagation();
      window.open(url);
      return;
    }

    if (closest(event.target, '.todo-content', this)) {
      event.preventDefault();
      event.stopPropagation();
      if (this.namespacedTrigger('openpage', { bubbles: true, detail: { url } })) {
        if (event.ctrlKey || event.metaKey) {
          window.open(url);
        } else {
          window.tower.stack.load(url);
        }
      }
    }
  },

  handleCheckboxChange(event) {
    this.toggleTodoComplete(event.detail.checked);
  },

  toggleTodoComplete(isCompleted) {
    const todo = $(this);
    const todoId = this.dataset.guid;
    const projectId = this.dataset.projectGuid;
    const url = `/projects/${projectId}/todos/${todoId}${(isCompleted ? '/complete/' : '/reopen/')}`;
    const isSubTodo = this.classList.contains('sub_todo');
    $.ajax({
      url,
      dataType: 'json',
      data: isSubTodo ? { skip_init_sequence: true } : {},
      type: 'post',
      success: (result) => {
        const newTodo = $(result.html);
        const runner = $('.runner.on', todo);

        resourceSubject('todo').next('update', {
          id: todo.attr('id').split('_')[1],
          html: result.html,
        });

        this.namespacedTrigger('toggle-complete', {
          bubbles: true,
          detail: { todo, newTodo, isCompleted },
        });

        if (runner.length) {
          todo.one('transitionend', () => {
            setTimeout(() => {
              this.handleTodo(newTodo, isCompleted);
            }, 500);
          });

          runner.removeClass('on');
        } else {
          this.handleTodo(newTodo, isCompleted);
        }
      },
    });
  },

  handleTodo(newTodo, isCompleted) {
    const todo = $(this);
    const list = todo.closest('.todolist');
    const todos = isCompleted ? list.find('.todos-completed') : list.find('.todos-uncompleted');

    if ($('.tr-page[opened]').length) {
      todo.replaceWith(newTodo);

      if (isCompleted) {
        $('.tr-page[opened]').trigger('todocomplete', [todo, list, newTodo, list]);
      } else {
        $('.tr-page[opened]').trigger('todoreopen', [todo, list, newTodo, list]);
      }
    } else if ($('#page-todo').length) {
      todo.replaceWith(newTodo);

      if (isCompleted) {
        $('.workspace .page:last .page-inner').trigger('todocomplete', [todo, list, newTodo, list]);
      } else {
        $('.workspace .page:last .page-inner').trigger('todoreopen', [todo, list, newTodo, list]);
      }
    } else if (isCompleted) {
      const expandedTodo = todo.closest('.expanded-todo');
      if (expandedTodo.length) {
        expandedTodo.fadeTo(200, 0);
        expandedTodo.slideUp(200, () => {
          expandedTodo.remove();

          $('.workspace .page:last .page-inner').trigger('todocomplete', [todo, list, newTodo, list]);
        });
      } else {
        todo.fadeTo(200, 0);
        todo.slideUp(200, () => {
          todo.remove();
          newTodo.prependTo(todos);

          $('.workspace .page:last .page-inner').trigger('todocomplete', [todo, list, newTodo, list]);
        });
      }
    } else {
      todo.fadeOut(() => {
        todo.remove();
        newTodo.appendTo(todos);

        $('.workspace .page:last .page-inner').trigger('todoreopen', [todo, list, newTodo, list]);
      });
    }

    window.tower.adjustReadableTime(newTodo);
    window.tower.initPermission(newTodo);
  },

  destroyAssigneeTooltip() {
    if (this.tooltip) {
      this.tooltip.destroy();
      this.tooltip = null;
    }
  },

  edit() {
    const button = this.querySelector('.edit.action');
    if (this.editable && button) button.click();
  },

  disconnected() {
    this.destroyAssigneeTooltip();
    this.stopListening();
  },
});
